





















import Vue from 'vue';
import customerVuex from '../../customer/vuex/common';

export default Vue.extend({
  mixins: [customerVuex],
  mounted() {
    window.addEventListener('message', (messageEvent) => {
      const data = messageEvent.data;
      if (data === 'loaded') {
        this.loaded = true;
      }
      if (data === 'close') {
        this.$store.commit('HIDE_CHAT');
      }
      if (data === 'max') {
        this.width = this.defaultWidth;
        this.height = this.defaultHeight;
      }
      if (data === 'min') {
        this.width = '122px';
        this.height = '31px';
      }
      if (data.msg === 'resize') {
        if (data.value < 1) {
          this.$store.commit('HIDE_CHAT');
        } else {
          this.height = `${39 + 30 * data.value}px`;
        }
      }
    }, false);
    this.width = this.defaultWidth;
    this.height = this.defaultHeight;
  },
  data() {
    return {
      defaultWidth: '300px',
      defaultHeight: '345px',
      width: 'auto',
      height: 'auto',
      loaded: false,
    };
  },
  computed: {
    styles(): any {
      return {
        width: this.width,
        height: this.height,
      };
    },
  },
  watch: {
    showChat(val) {
      if (val) {
        (this.$refs.plugin as any).src = 'https://weixin.drip.im/wx-member/chat?plugin=true&openid=' + this.chatOpenid;
        this.width = this.defaultWidth;
        this.height = this.defaultHeight;
        this.loaded = false;
      }
    },
  },
});
